// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blocked-community-postcard-main-container {
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  margin-bottom: 10px;
}
.blocked-community-postcard {
  display: flex;
  flex-direction: column;
  /* justify-content: center;
      align-items: center; */
  margin: 10px;
  padding: 14px 14px;
  overflow-x: auto;
  border-width: 0px;
  border-radius: 20px;
  /* box-shadow: 0px 2px 8px rgb(139, 146, 149); */
  background-color: #f9f9f8;
  opacity: 0.9;
  width: 340px;
}

@media screen and (min-width: 768px) {
  .blocked-community-postcard {
    width: 340px;
  }
}

@media screen and (min-width: 1024px) {
  .blocked-community-postcard {
    width: 420px;
  }
}

.blocked-community-text {
  font-family: sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #707070;
}
.blocked-community-req-send-time-text{
  font-family: sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #707070;
  margin-bottom: 2px;
}
.blocked-community-time-text {
  font-family: sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #707070;
}

.unblock-modal-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.unblock-modal-header h1 {
  font-family: sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #373334;
}
.unblock-modal-header button {
  border: none;
  background-color: transparent;
  outline: none;
}
.block-modal-close-icon {
  font-size: 22px;
}
.unblock-request-textarea {
  width: 330px;
  padding: 15px 18px;
  border-width: 1.6px;
  border-color: #707070c1;
  margin: 8px 0px;
}
.unblock-req-send-button {
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);
  color: white;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  outline: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Activites/BlockedCommunities/blockedCommunity.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB;4BAC0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0EAA0E;EAC1E,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;AAC1B","sourcesContent":[".blocked-community-postcard-main-container {\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n  margin-bottom: 10px;\r\n}\r\n.blocked-community-postcard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* justify-content: center;\r\n      align-items: center; */\r\n  margin: 10px;\r\n  padding: 14px 14px;\r\n  overflow-x: auto;\r\n  border-width: 0px;\r\n  border-radius: 20px;\r\n  /* box-shadow: 0px 2px 8px rgb(139, 146, 149); */\r\n  background-color: #f9f9f8;\r\n  opacity: 0.9;\r\n  width: 340px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .blocked-community-postcard {\r\n    width: 340px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .blocked-community-postcard {\r\n    width: 420px;\r\n  }\r\n}\r\n\r\n.blocked-community-text {\r\n  font-family: sans-serif;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #707070;\r\n}\r\n.blocked-community-req-send-time-text{\r\n  font-family: sans-serif;\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n  color: #707070;\r\n  margin-bottom: 2px;\r\n}\r\n.blocked-community-time-text {\r\n  font-family: sans-serif;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #707070;\r\n}\r\n\r\n.unblock-modal-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n}\r\n.unblock-modal-header h1 {\r\n  font-family: sans-serif;\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n  color: #373334;\r\n}\r\n.unblock-modal-header button {\r\n  border: none;\r\n  background-color: transparent;\r\n  outline: none;\r\n}\r\n.block-modal-close-icon {\r\n  font-size: 22px;\r\n}\r\n.unblock-request-textarea {\r\n  width: 330px;\r\n  padding: 15px 18px;\r\n  border-width: 1.6px;\r\n  border-color: #707070c1;\r\n  margin: 8px 0px;\r\n}\r\n.unblock-req-send-button {\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);\r\n  color: white;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: auto;\r\n  outline: none !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
